import React, { useEffect, useState } from 'react';
import { Grid, Radio, FormControlLabel, Typography } from '@material-ui/core';
import { Field, FieldProps, useFormikContext } from 'formik';
import RangeField from 'components/RangeField';
import { IExpandedMailingRule } from 'interfaces/MailingRule';
import { IMailingRuleSubformProps } from '../../interfaces';

const SubFormKeyRanges: React.FC<IMailingRuleSubformProps> = ({
  isEditable,
}: IMailingRuleSubformProps) => {
  const { values, setFieldValue } = useFormikContext<IExpandedMailingRule>();

  const isAggregatedByCustomer = values.aggregationType === 'CUSTOMER';
  const isAggregatedByContract = values.aggregationType === 'CONTRACT';

  const [onSetAll, setOnSetAll] = useState(false);

  const shouldFilterOnContractAging = values.shouldFilterOnContractAging;

  useEffect(() => {
    if (values.aggregationType === 'CONTRACT') {
      setShouldFilterOnContractAging(true);
      return;
    }
  }, [values, setFieldValue]);

  const setShouldFilterOnContractAging = (value: boolean) =>
    setFieldValue('shouldFilterOnContractAging', value, true);

  useEffect(() => {
    setOnSetAll(values.contractAging.max !== 0);
  }, []);

  useEffect(() => {
    if (!onSetAll) setShouldFilterOnContractAging(false);
  }, [isAggregatedByCustomer, onSetAll]);

  return (
    <Grid
      item
      xs={12}
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      {isAggregatedByCustomer && (
        <Grid
          data-cy="sub-form-keys-ranges__container--customer-aging"
          item
          xs={12}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs={12}>
            <Typography variant="h6">
              Atraso da chave de distribuição do Cliente
            </Typography>
          </Grid>
          <Grid
            data-cy="sub-form-keys-ranges__range-field--customer-aging"
            item
            xs={6}
          >
            <RangeField
              name="customerAging"
              labelBefore="De"
              disabled={!isEditable}
            />
          </Grid>
        </Grid>
      )}

      {(isAggregatedByCustomer || isAggregatedByContract) && (
        <Grid
          data-cy="sub-form-keys-ranges__container--should-filter-on-contract-aging"
          item
          xs={12}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs={12}>
            {isAggregatedByCustomer ? (
              <Typography variant="h6">Seleção de contratos</Typography>
            ) : (
              <Typography variant="h6">
                Atraso da chave de distribuição do Contrato
              </Typography>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            {isAggregatedByCustomer && (
              <Grid
                data-cy="sub-form-keys-ranges__radio-buttons--should-filter-on-contract-aging"
                item
                xs={12}
              >
                <Field name="shouldFilterOnContractAging">
                  {({ field }: FieldProps) => (
                    <Grid container direction="column">
                      <Grid item>
                        <FormControlLabel
                          value={false}
                          checked={!onSetAll}
                          control={<Radio />}
                          label="Todas"
                          disabled={!isEditable}
                          onChange={() => {
                            setShouldFilterOnContractAging(false);
                            setFieldValue('contractAging', { min: 0, max: 0 });
                            setOnSetAll(false);
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          value={true}
                          checked={onSetAll}
                          control={<Radio />}
                          disabled={!isEditable}
                          label="Selecionar"
                          onChange={() => {
                            setShouldFilterOnContractAging(true);
                            setFieldValue('contractAging', {
                              min: 0,
                              max: 0,
                            });
                            setOnSetAll(true);
                          }}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Field>
              </Grid>
            )}
            {(isAggregatedByContract ||
              (shouldFilterOnContractAging && onSetAll)) && (
              <Grid
                item
                xs={6}
                data-cy="sub-form-keys-ranges__range-field--contract-aging"
              >
                <RangeField
                  name="contractAging"
                  labelBefore="De"
                  disabled={!isEditable}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default SubFormKeyRanges;
